import { render, staticRenderFns } from "./DropdownMultiple.vue?vue&type=template&id=08bca77c"
import script from "./DropdownMultiple.vue?vue&type=script&lang=js"
export * from "./DropdownMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports